import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/t_logo.png'


const _hoisted_1 = {
  key: 0,
  class: "mt-2 d-flex flex-fill justify-content-center"
}
const _hoisted_2 = {
  class: "",
  style: {"max-width":"800px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid"
  })
], -1)
const _hoisted_4 = { class: "text-center fs-1 fw-bold mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 mb-4 text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-inline-block text-start" }, [
    /*#__PURE__*/_createTextVNode(" Webユーザー登録をするには、まず空メールを送信してください。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("その後、登録用のURLを記載したメールをお送りします ")
  ])
], -1)
const _hoisted_6 = { class: "card card-body p-5 mt-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "メール受信許可設定のお願い", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "携帯会社（通信回線事業者）のメールをご利用の方は下記ドメインからのメール受信許可の設定をお願いいたします。", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "fs-3" }
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "設定方法については下記の携帯会社サイトをご参照ください。", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "card card-body p-5 mt-4" }
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "「空メールを送る」を押してメールソフトが起動しない場合やご利用のメールソフトから空メールを送る場合は下記のメールアドレスにお送りください。 "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_23 = { class: "mt-4 d-flex" }
const _hoisted_24 = { class: "input-group" }
const _hoisted_25 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (!_ctx.sendDone)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.configs['mail_domain']), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.configs['keitai_kaisha_docomo'],
                    target: "_blank"
                  }, "NTTドコモ 受信リスト／拒否リスト設定", 8, _hoisted_15)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.configs['keitai_kaisha_au'],
                    target: "_blank"
                  }, "au(KDDI) 受信リスト設定", 8, _hoisted_16)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.configs['keitai_kaisha_softbank'],
                    target: "_blank"
                  }, "ソフトバンク 受信許可リスト設定", 8, _hoisted_17)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.configs['keitai_kaisha_rakuten'],
                    target: "_blank"
                  }, "楽天モバイル 受信リスト／拒否リストの設定・変更・削除（楽メール）", 8, _hoisted_18)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("a", {
                class: "btn btn-primary btn-lg text-white flex-fill",
                href: _ctx.mailto
              }, [
                _createVNode(_component_fa, {
                  class: "me-1",
                  icon: "envelope"
                }),
                _createTextVNode("空メールを送る")
              ], 8, _hoisted_21)
            ]),
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("input", {
                  class: "form-control form-control-lg text-center",
                  value: _ctx.mailAddress,
                  readonly: ""
                }, null, 8, _hoisted_25),
                _createElementVNode("button", {
                  class: "btn btn-lg border-start-0",
                  style: {"border-color":"lightgray","background-color":"lightgray"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copy()))
                }, [
                  _createVNode(_component_fa, {
                    class: "me-1 text-secondary",
                    icon: "copy"
                  })
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}